import React from 'react';
import { Cloud, Blocks, CreditCard, Shield, Globe, Inbox, Search } from 'lucide-react';
import { platformFeatures } from '../../mock';

const iconMap = { Cloud, Blocks, CreditCard, Shield, Globe, Inbox, Search };

const FeatureVisual = ({ icon, tag }) => {
  const Icon = iconMap[icon];
  return (
    <div className="relative h-[220px] rounded-xl border overflow-hidden flex items-center justify-center" style={{ borderColor: 'var(--yb-border)', background: 'linear-gradient(135deg, #FBFAF7, #F3F1EA)' }}>
      <div className="absolute top-4 left-4 px-2.5 py-1 rounded-full bg-white/85 backdrop-blur-sm border text-[11px]" style={{ borderColor: 'var(--yb-border)', color: 'var(--yb-text)' }}>
        {tag}
      </div>
      <div className="relative">
        <div className="absolute inset-0 blur-2xl opacity-60 rounded-full" style={{ background: 'radial-gradient(circle, rgba(79,70,229,0.35), transparent 70%)' }} />
        <div className="relative w-20 h-20 rounded-2xl bg-white border shadow-lg flex items-center justify-center" style={{ borderColor: 'var(--yb-border)' }}>
          <Icon size={32} strokeWidth={1.5} style={{ color: 'var(--yb-indigo)' }} />
        </div>
      </div>
    </div>
  );
};

const PlatformFeatures = () => {
  return (
    <section id="platform" className="py-24 lg:py-32 bg-white">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-16">
          <p className="text-[13px] uppercase tracking-widest mb-4" style={{ color: 'var(--yb-muted)' }}>Everything included</p>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-[-0.02em]" style={{ color: 'var(--yb-ink)' }}>
            The hard parts,<br />
            <span className="italic" style={{ color: 'var(--yb-muted)' }}>already handled.</span>
          </h2>
          <p className="mt-6 text-[16px] leading-relaxed" style={{ color: 'var(--yb-muted)' }}>
            Hosting, payments, security, integrations — the things that usually stop non-technical
            builders in their tracks. YouBuild takes care of them, so you can stay focused on your
            idea.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {platformFeatures.map((f, idx) => (
            <div
              key={f.title}
              className={`group rounded-2xl border p-5 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 ${
                idx === 0 ? 'lg:col-span-2' : ''
              }`}
              style={{ borderColor: 'var(--yb-border)', backgroundColor: '#FBFAF7' }}
            >
              <FeatureVisual icon={f.icon} tag={f.tag} />
              <div className="mt-5">
                <h3 className="font-serif text-2xl tracking-tight" style={{ color: 'var(--yb-ink)' }}>{f.title}</h3>
                <p className="mt-2 text-[14.5px] leading-relaxed" style={{ color: 'var(--yb-muted)' }}>
                  {f.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PlatformFeatures;
